import moment, { Moment } from 'moment'
import { createSelector } from 'reselect'

import { DEFAULT_DATE_FORMAT } from 'constants/date'
import { CriterionV2 } from 'constants/service'

import { RootState } from 'core/reducers'

import { ADMINISTRATION_STATUSES, AdministerTypeProps, AdministrationStatusProps } from '../constants'

export const getAdministrationsSelector = (state: RootState) => state.administrations

export const getAdministrationsListSelector = createSelector(
  [getAdministrationsSelector],
  (state) => state.list.data,
)

interface GetCriteriaProps {
  activeOnly?: boolean
  administerType?: AdministerTypeProps
  administrationDateRange?: Moment[]
  administrationStatus?: AdministrationStatusProps
  childId?: number
  pendingOnly?: boolean
  search?: string
}

export const getCriteria = ({
  activeOnly,
  administerType,
  administrationDateRange,
  administrationStatus,
  childId,
  pendingOnly,
  search,
}: GetCriteriaProps): CriterionV2[] => {
  const criteria = [] as any

  if (childId) {
    criteria.push({
      field: 'or[0][medicationForm.child][eq]',
      value: childId,
    })

    criteria.push({
      field: 'or[0][child][eq]',
      value: childId,
    })
  }

  if (administrationDateRange && administrationDateRange[0] && administrationDateRange[1]) {
    criteria.push({
      comparator: 'after',
      field: 'createdAt',
      value: `${moment(administrationDateRange[0]).format(DEFAULT_DATE_FORMAT)} 00:00:00`,
    })

    criteria.push({
      comparator: 'before',
      field: 'createdAt',
      value: `${moment(administrationDateRange[1]).format(DEFAULT_DATE_FORMAT)} 23:59:59`,
    })
  }

  if (administrationStatus) {
    criteria.push({
      field: 'status',
      value: administrationStatus,
    })
  }

  if (administerType) {
    criteria.push({
      field: 'type',
      value: administerType,
    })
  }

  if (search) {
    criteria.push({
      field: 'concatenable',
      value: search,
    })
  }

  if (activeOnly && !administrationStatus) {
    criteria.push({
      field: 'status[]',
      value: ADMINISTRATION_STATUSES.ADMINISTERED,
    })

    criteria.push({
      field: 'status[]',
      value: ADMINISTRATION_STATUSES.SIGNED,
    })
  }

  if (pendingOnly && !administrationStatus) {
    criteria.push({
      field: 'status[]',
      value: ADMINISTRATION_STATUSES.SCHEDULED,
    })

    criteria.push({
      field: 'status[]',
      value: ADMINISTRATION_STATUSES.MISSED,
    })
  }

  return criteria
}

export const getAvailableCriteria = ({
  administrationDateRange,
  childId,
}: GetCriteriaProps): CriterionV2[] => {
  const criteria = [] as any

  if (childId) {
    criteria.push({
      field: 'child',
      value: childId,
    })
  }

  if (administrationDateRange && administrationDateRange[0] && administrationDateRange[1]) {
    criteria.push({
      comparator: 'after',
      field: 'date',
      value: `${moment(administrationDateRange[0]).format(DEFAULT_DATE_FORMAT)} 00:00:00`,
    })

    criteria.push({
      comparator: 'before',
      field: 'date',
      value: `${moment(administrationDateRange[1]).format(DEFAULT_DATE_FORMAT)} 23:59:59`,
    })
  }

  return criteria
}
